/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface AdminBenutzerverwaltungControllerSendPasswordResetV1$Params {
  id: string;
}

export function adminBenutzerverwaltungControllerSendPasswordResetV1(http: HttpClient, rootUrl: string, params: AdminBenutzerverwaltungControllerSendPasswordResetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, adminBenutzerverwaltungControllerSendPasswordResetV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

adminBenutzerverwaltungControllerSendPasswordResetV1.PATH = '/v1/benutzerverwaltung/{id}/passwort-zuruecksetzen';
